<template>
  <div class="loader-wrapper" v-if="showLoader">
    <div class="loader"><span></span><span></span><span></span><span></span><span></span></div>
  </div>
  <router-view/>
</template>
<script lang="ts" setup>
  import { onMounted, ref, watch, onUnmounted } from "vue"
  import { useRouter } from 'vue-router'
  import { useLoaderStore } from '@/store/loader'
  import { storeToRefs } from 'pinia'

  let router = useRouter()
  const { showLoader } = storeToRefs(useLoaderStore())

  watch(
      () => router,
      () => {

      },
      { deep: true },
  );

  onMounted(() => {

  })
  onUnmounted(() => {

  })
</script>
<style lang="scss">

</style>
